import React from 'react';
import { Mail, Linkedin, ArrowRight, Sparkles } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 bg-slate-900 text-white px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-56">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-57">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" data-id="element-58"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-59"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-5 animate-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-60"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative" data-id="element-61">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500/20 rounded-2xl mb-6 backdrop-blur-sm border border-blue-400/30" data-id="element-62">
          <Sparkles className="h-8 w-8 text-blue-400" data-id="element-63" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent" data-id="element-64">
          Get in Touch
        </h2>
        <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-65">
          Interested in discussing the future of financial infrastructure,
          post-quantum security, or potential collaborations?
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-66">
          <a href="https://www.linkedin.com/in/arthur-miller-64b32165/" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white rounded-xl font-medium transition-all w-full sm:w-auto justify-center shadow-lg hover:shadow-xl hover:scale-105 transform duration-200" data-id="element-67">
            <Linkedin className="h-5 w-5 group-hover:scale-110 transition-transform" data-id="element-68" />
            Connect on LinkedIn
            <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-69" />
          </a>
        </div>

        {/* Additional info cards */}
        <div className="grid md:grid-cols-3 gap-6 mt-16 mb-16" data-id="element-70">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50" data-id="element-71">
            <div className="text-blue-400 font-bold text-lg mb-2" data-id="element-72">Location</div>
            <div className="text-slate-300" data-id="element-73">Arizona, United States</div>
          </div>
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50" data-id="element-74">
            <div className="text-blue-400 font-bold text-lg mb-2" data-id="element-75">Role</div>
            <div className="text-slate-300" data-id="element-76">Founder & CEO, FiQIS</div>
          </div>
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50" data-id="element-77">
            <div className="text-blue-400 font-bold text-lg mb-2" data-id="element-78">
              Expertise
            </div>
            <div className="text-slate-300" data-id="element-79">Financial Infrastructure</div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-slate-800 text-slate-400 text-sm flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-80">
          <p data-id="element-81">
            &copy; {new Date().getFullYear()} Arthur Miller. All rights
            reserved.
          </p>
          <p data-id="element-82">Founder & CEO, FiQIS</p>
        </div>
      </div>
    </section>;
}